export default __webpack_public_path__ + "static/media/mesosphere.ffd5a82a.svg";